module.exports = __webpack_public_path__ + "img/3.d09598e2.jpg";